import React from "react";
import {
  Container,
  Card,
  Row,
  Col,
  Badge,
} from "reactstrap";

import Avatar from "../../common/components/Avatar";
import { buildAddress } from "../../common/helpers/functions";
import { Attendee } from "../../api";

interface PropsAttendeeDetails extends Attendee {
  showContactInfo?: boolean;
}

const AttendeeDetails: React.FC<PropsAttendeeDetails> = (props) => {
  return (
    <Card className="p-3 box-shadow">
      <div className="attendeeDetails">
        <Container className="p-0">
          <Row>
            <Col
              xs="3"
              className="text-center mb-3 h-100 justify-content-center align-items-center"
            >
              <Badge color="transparent">
                <Avatar
                  size="md"
                  id={props.email}
                  name={
                    props.name ? props.name : props.email
                  }
                  src={props.photoUri}
                  srcSet={props.photoUri}
                />
              </Badge>
            </Col>
            <Col xs="7" className="text-left">
              <p className="mt-2">
                <span className="text-primary text-center fs-9 fw-6">
                  {props.name
                    ? props.name
                    : "Name not available"}{" "}
                </span>
                <span className="text-uppercase">{props.jobTitle}</span>
              </p>
            </Col>
            <Col>
              <div className="attendeeDetails__contact">
                {!!props.company && (<p>{props.company}</p>)}
                {!!props.fcaNumber && (<p>FCA Number: {props.fcaNumber}</p>)}
                {props.showContactInfo && (
                  <>
                    {!!props.email && (<p>{props.email}</p>)}
                    {!!props.phone && (<p>{props.phone}</p>)}
                    {!!props.address && Object.keys(props.address).length !== 0 && (<p>{buildAddress(props.address)}</p>)}
                  </>)}
                {!!props.bio && (<p>{props.bio}</p>)}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Card>
  );
};

export default AttendeeDetails;
